var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"u-absolute u-right-0 u-top-0 u-cursor-pointer",attrs:{"data":"basket-line-item-remove"}},[_c('i',{on:{"click":function($event){return _setup.removeFromBasket()}}},[_c('IconClose',{staticClass:"sub-lg:u-scale-80"})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }